import { FunctionComponent, h } from 'preact';
import { StyledLoadingButton } from './loading-button.styles';
import { ButtonProps } from '../button/button';
import Loader from '@components/atoms/loader/loader';

export interface LoadingButtonProps extends ButtonProps {
  isLoading: boolean;
}

const LoadingButton: FunctionComponent<LoadingButtonProps> = ({
  isLoading,
  children,
  ...otherProps
}) => {
  return (
    <StyledLoadingButton {...otherProps} $isLoading={isLoading}>
      {!isLoading && children}
      {isLoading && <Loader />}
    </StyledLoadingButton>
  );
};

export default LoadingButton;
